import { ProviderMethods } from './AnalyticsProvider';
import window from 'common/utils/window-or-global';
import { map } from 'lodash';

import logger from 'itrvl-logger';
const log = logger(__filename);

export default function Segment(key) {
  // Build an event queue if we have not loaded yet
  if (!window.analytics) {
    window.analytics = [];
  }

  const analytics = window.analytics;

  // If we have the real segment or our stub then move on
  if (analytics.initialize || analytics.invoked) {
    return analytics;
  }

  // Okay, we are stubbing
  analytics.invoked = true;

  // Build an event queue handler for each analytics method
  map(ProviderMethods, method => {
    analytics[method] = (...methodArgs) => {
      // Only store tracking if we will load segment eventually
      if (key && key !== '') {
        methodArgs.unshift(method);
        analytics.push(methodArgs);
        log.debug('segment', methodArgs);
      }
      return analytics;
    };
  });

  // Load analytics
  if (key && key !== '') {
    log.debug('Load Segment:', key);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    const protocol = document.location.protocol === 'https:' ? 'https://' : 'http://';
    const extension = process.env.NODE_ENV === 'production' ? 'min.js' : 'js';
    script.src = `${protocol}cdn.segment.com/analytics.js/v1/${key}/analytics.${extension}`;
    const head = document.getElementsByTagName('head')[0];
    head.insertBefore(script, head.childNodes[0]);
  } else {
    log.warn('No segment key provided');
  }

  return analytics;
}
